import zxcvbn from 'zxcvbn';

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*(\d|\W)).{8,16}$/;

export const getPasswordStrength = (password) => {
  if (!password) return 0;
  const result = zxcvbn(password);
  return result.score;
};

export const getVerificationErrors = (password) => {
  const errors = [];
  if (!password) return errors;
  if (password.length < 8) errors.push("min 8 caracteres");
  if (!/[a-z]/.test(password)) errors.push("una minúscula");
  if (!/[A-Z]/.test(password)) errors.push("una mayúscula");
  if (!/(\d|\W)/.test(password)) errors.push("un número o símbolo");
  return errors;
};


export const getVerificationMessage = (password) => {
  const errors = getVerificationErrors(password);
  if (errors.length === 0) return "";
  return `Falta:\n${errors.join('\n')}`;
}

export const getPasswordStrengthColor = (score) => {
  switch (score) {
    case 0:
    case 1:
      return '#f44336'; // weak (red)
    case 2:
      return '#ff9800'; // fair (orange)
    case 3:
      return '#ffeb3b'; // good (yellow)
    case 4:
      return '#4caf50'; // strong (green)
    default:
      return '#e0e0e0';
  }
};

export const getPasswordStrengthText = (score) => {
  switch (score) {
    case 0:
    case 1:
      return 'Débil';
    case 2:
      return 'Regular';
    case 3:
      return 'Buena';
    case 4:
      return 'Fuerte';
    default:
      return '';
  }
};
